import React from 'react';

import { CodeCoach } from '../Materials/CodeCoach/CodeCoach';
import { Theory } from '../Materials/Theory/Theory';
import { Question } from '../Materials/Question/Question';
import { TIY } from '../Materials/TIY/TIY';
import { CodeRepo } from '../Materials/CodeRepo/CodeRepo';
import { LessonPage } from '../MaterialGroups/LessonPage/LessonPage';
import { Lesson } from '../MaterialGroups/Lesson/Lesson';
import { Module } from '../MaterialGroups/Module/Module';
import { Course } from '../MaterialGroups/Course/Course';
import { IMaterialProps } from '../../global-interface';
import { CodeProject } from '../Materials/CodeProject/CodeProject';
import { ExternalResource } from '../Materials/ExternalResource/ExternalResource';
import { MaterialType, IMaterial } from '../../../../api/private/learn-engine-api/learn-engine-api.interface';
import { AIChatPlayground } from '../Materials/AIChatPlayground/AIChatPlayground';

const materialsMap: Record<number, (props: IMaterialProps) => JSX.Element> = {
	[MaterialType.Theory]: Theory,
	[MaterialType.Question]: Question,
	[MaterialType.TryItYourself]: TIY,
	[MaterialType.CodeCoach]: CodeCoach,
	[MaterialType.CodeRepo]: CodeRepo,
	[MaterialType.CodeProject]: CodeProject,
	[MaterialType.LessonPage]: LessonPage,
	[MaterialType.Lesson]: Lesson,
	[MaterialType.Module]: Module,
	[MaterialType.Course]: Course,
	[MaterialType.ModuleQuiz]: Lesson,
	[MaterialType.SkipAhead]: Lesson,
	[MaterialType.Booster]: Lesson,
	[MaterialType.ExternalResource]: ExternalResource,
	[MaterialType.AIChat]: AIChatPlayground,
};

export function MaterialRenderer({
	materialInfo,
	children,
	hideHeader,
	hideCertificate,
	isExpanded,
	className,
}: IMaterialProps): JSX.Element {
	const Component: (props: IMaterialProps) => JSX.Element = materialsMap[materialInfo?.header.typeId];

	return Component ? (
		<Component
			materialInfo={materialInfo}
			hideCertificate={hideCertificate}
			hideHeader={hideHeader}
			isExpanded={isExpanded}
			className={className}
		>
			{(children as IMaterial[])?.map((childData, index) => {
				if (childData.materialInfo) {
					return (
						<MaterialRenderer
							key={index}
							materialInfo={{
								...(childData as IMaterial).materialInfo,
								options: {
									parentType: materialInfo.header.typeId,
								},
							}}
							isExpanded={isExpanded}
							hideCertificate={hideCertificate}
							hideHeader={hideHeader}
							className={className}
						>
							{(childData as IMaterial).children}
						</MaterialRenderer>
					);
				}
				return null;
			})}
		</Component>
	) : null;
}
